// document.addEventListener("DOMContentLoaded", function() {
//   var backButtons = document.querySelectorAll(".collection-hero__back");
//   console.log("Found back buttons: ", backButtons);
//   if (!backButtons) {
//     return;
//   }
//
//   const url = new URL(window.location.href);
//   const path = url.pathname.split("/");
//   console.log("Path: ", path);
//   if(path.includes("products")) {
//     console.log("Product page, not adding back buttons");
//     return;
//   }
//   backButtons.forEach(function(backButton) {
//     backButton.addEventListener("click", function(event) {
//       event.preventDefault();
//       window.history.back();
//     });
//   });
// });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (!model.modelViewerUI) return;
    model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let timeout;

  return async (...args) => {
    return new Promise((resolve) => {
      clearTimeout(timeout);

      timeout = setTimeout(async () => {
        const result = await fn.apply(this, args);
        resolve(result);
      }, wait);
    });
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined && this.mainDetailsToggle) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
    knocking.enableScroll();
    knocking.hideBlur();
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer(event);
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    const closeX = this.querySelector("#menu-drawer-close-x");
    if (closeX) {
      closeX.addEventListener("click", () => {
        this.closeMenuDrawer;
        // knocking.enableScroll();
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    knocking.showBlur();
    knocking.disableScroll();
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    let templatePopup = this.querySelector(".template-popup");
    if (templatePopup) {
      templatePopup.loadContent();
    }
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(
      `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
        "data-media-id"
      )}"])`
    ).forEach((element) => {
      element.classList.remove("active");
    });
    const activeMedia = this.querySelector(
      `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
    );
    activeMedia.classList.add("active");
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (
      activeMedia.nodeName == "DEFERRED-MEDIA" &&
      activeMedia.querySelector("template").content.querySelector(".js-youtube")
    )
      activeMedia.loadContent();
  }
}

customElements.define("product-modal", ProductModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    if (button) {
      button.addEventListener("click", () => {
        document.querySelector(this.getAttribute("data-modal")).show(button);
      });
    }
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.deferredPoster = this.querySelector('[id^="Deferred-Poster-"]');
    if (this.deferredPoster) {
      this.deferredPoster.addEventListener(
        "click",
        this.loadContent.bind(this)
      );
    }
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (
      !this.slider ||
      !this.nextButton ||
      typeof ResizeObserver == "undefined"
    )
      return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

// class VariantSelects extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener("change", this.onVariantChange);
//     this.productId = this.dataset.productId;
//     this.productTags = this.getProductTags();
//     this.variantData = this.getVariantData();
//     this.getVariantInventory();
//     this.getVariantContinueSellingPolicy();
//     this.addFeaturePropertiesToVariantData();
//     this.checkShippingFeatures();

//     // switches
//     this.shipsByBanner = {
//       hide: () => {
//         if (document.querySelector("#product-shipsby-notice")) {
//           document.querySelector("#product-shipsby-notice").style.display =
//             "none";
//         }
//       },
//       show: () => {
//         if (document.querySelector("#product-shipsby-notice")) {
//           document.querySelector("#product-shipsby-notice").style.display =
//             "flex";
//         }
//       },
//     };
//   }

//   connectedCallback() {
//     /**
//      * @type {HTMLElement | null}
//      * */
//     this.section = this.closest("section");
//     if (!this.section) {
//       console.error("Could not find section element for variant-selects");
//       return;
//     }
//     this.sectionId = this.section.classList[0].replace("product-section--", "");
//     /**
//      * @type {HTMLInputElement | null}
//      * */
//     this.skuElement = this.section.querySelector("input[name='sku']");

//     this.extendedOfferButton = this.section.querySelector(
//       `#extended-offer-button-${this.sectionId}`
//     );
//     // delete ?
//     this.updateOptions();
//     this.updateMasterId();
//     this.setVariantUi(this.currentVariant.state.ui);
//     this.toggleExtendedOfferButton(!this.currentVariant.available);

//     const firstAvailableVariant = this.variantData.find(
//       (variant) => variant.available
//     );

//     messenger.listen(messenger.topics.RESET_PRODUCT_FORM, () => {
//       console.log("resetting UI in variant-selects");
//       const firstAvailableVariant = this.getFirstAvailableVariant();
//       this.initUi(firstAvailableVariant);
//     });

//     window.addEventListener("message", (event) => {
//       if (event.data.type === "ships_by_notification_ready") {
//         this.initUi();
//       }
//     });

//     // this.initUi(firstAvailableVariant);
//   }

//   getFirstAvailableVariant() {
//     return (
//       this.variantData.find((variant) => variant.available) ||
//       this.variantData[0]
//     );
//   }

//   // handlers

//   onVariantChange() {
//     // console.log("onVariantChange");
//     this.updateOptions();
//     this.updateMasterId();
//     // console.log("this.currentVariant: ", this.currentVariant);
//     this.toggleAddButton(true, "", false);
//     this.toggleExtendedOfferButton(false);
//     // this.updatePickupAvailability();
//     if (!this.currentVariant) {
//       this.toggleAddButton(true, "", true);
//       this.setUnavailable();
//       this.renderProductInfo();
//     } else {
//       this.updateMedia();
//       this.updateURL();
//       this.updateVariantInput();
//       this.renderProductInfo();
//       this.setVariantUi(this.currentVariant.state.ui);
//       this.toggleExtendedOfferButton(!this.currentVariant.available);
//       this.setShipsByVisibility(this.currentVariant.available);
//       this.setHolidayShippingVisibility(this.currentVariant.available);
//     }

//     this.postMessageVariantChanged();
//   }

//   /** @param {boolean} visible */
//   setShipsByVisibility(visible) {
//     /** @type {Array<HTMLElement> | null} */
//     const shipsByElementsArray = Array.from(
//       document.querySelectorAll("ships-by-notification")
//     );
//     if (!shipsByElementsArray || shipsByElementsArray.length === 0) return;
//     const shipsByElements = shipsByElementsArray.filter((item) => {
//       const section = item.getAttribute("data-section");
//       return section && section.includes("main");
//     });
//     if (!shipsByElements) return;
//     if (visible) {
//       shipsByElements.forEach((element) => {
//         element.style.display = "block";
//       });
//     } else {
//       shipsByElements.forEach((element) => {
//         element.style.display = "none";
//       });
//     }
//   }

//   /** @param {boolean} visible */
//   setHolidayShippingVisibility(visible) {
//     /** @type {HTMLElement | null} */
//     const holidayShippingElement = document.querySelector(
//       "holiday-shipping-countdown"
//     );
//     if (!holidayShippingElement) return;
//     if (visible) {
//       holidayShippingElement.style.display = "block";
//     } else {
//       holidayShippingElement.style.display = "none";
//     }
//   }

//   initUi(variant = null) {
//     if (!variant) {
//       variant = this.getVariantFromUrl() || this.getFirstAvailableVariant();
//     }
//     // console.log("init ui Variant: ", variant);
//     this.setVariantSelectsToValues(variant.options);
//     this.setShipsBy(this.productTags);

//     const event = new Event("change", {
//       bubbles: true,
//     });

//     this.dispatchEvent(event);

//     // this.hideFeatureUiElements();
//     // this.updateOptions();
//     // this.updateMasterId(variant);
//     // this.updateVariantInput(variant);

//     // this.setVariantUi(this.currentVariant.state.ui);
//     // this.postMessageVariantChanged();
//     // this.updateMedia();
//   }

//   /**
//    *
//    * @param {string[]} tags
//    */
//   setShipsBy(tags) {
//     const shipsByObject = knocking.getTagShippingDate(tags);
//     this.postMessageShipsBy(shipsByObject.shortDate);
//     /**
//      * @type {HTMLInputElement | null}
//      * */
//     let shipsByInput;
//     /**
//      * @type {HTMLElement | null}
//      * */
//     const section = this.closest("section");

//     shipsByInput = section ? section.querySelector("#ships-by-input") : null;
//     if (shipsByInput) {
//       shipsByInput.value = shipsByObject.longDate;
//     }
//   }

//   setVariantSelectsToValues(options) {
//     const selects = Array.from(this.querySelectorAll("select"));

//     // console.log('setting selects to values: ', options);

//     for (let i = 0; i < options.length; i++) {
//       const option = options[i];
//       selects[i].value = option;
//     }
//   }

//   postMessageVariantChanged() {
//     // When variant is changed post a message with the variant's data
//     messenger.emmit(messenger.topics.VARIANT_CHANGE, this.currentVariant);
//   }

//   /**
//    *
//    * @param {string} shippingDate
//    */
//   postMessageShipsBy(shippingDate) {
//     window.postMessage({
//       type: "update_ships_by_notification",
//       productId: this.productId,
//       shippingDate: shippingDate,
//     });
//   }

//   toggleExtendedOfferButton(show) {
//     // show extended offer button if exists
//     if (this.extendedOfferButton) {
//       this.extendedOfferButton.style.display = show ? "flex" : "none";
//     }
//   }

//   renderProductInfo() {
//     fetch(
//       `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
//     )
//       .then((response) => response.text())
//       .then((responseText) => {
//         const id = `price-${this.dataset.section}`;
//         const html = new DOMParser().parseFromString(responseText, "text/html");
//         const destination = document.getElementById(id);
//         const source = html.getElementById(id);

//         if (source && destination) destination.innerHTML = source.innerHTML;

//         const price = document.getElementById(`price-${this.dataset.section}`);
//         if (price) {
//           price.classList.remove("visibility-hidden");
//         }
//         this.toggleAddButton(
//           !this.currentVariant.available,
//           window.variantStrings.unavailable
//         );
//       });
//   }

//   toggleAddButton(disable = true, text, modifyClass = true) {
//     const form = document.getElementById(
//       `product-form-${this.dataset.section}`
//     );

//     if (!form) return;
//     const addButton = form.querySelector('[name="add"]');

//     if (disable) {
//       addButton.setAttribute("disabled", true);
//       if (text) addButton.textContent = text;
//     } else {
//       addButton.removeAttribute("disabled");
//       addButton.textContent =
//         window.variantStrings[this.currentVariant.state.ui];
//     }

//     if (!modifyClass) return;
//   }

//   // update
//   getVariantFromUrl() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const variantId = urlParams.get("variant");
//     if (!variantId) return null;
//     const variant = this.variantData.find((variant) => variant.id == variantId);
//     if (!variant) return null;
//     return variant;
//   }

//   updateOptions() {
//     this.options = Array.from(
//       this.querySelectorAll("select"),
//       (select) => select.value
//     );
//   }

//   updateMasterId(variant = null) {
//     if (variant) {
//       this.currentVariant = variant;
//     } else {
//       this.currentVariant = this.getVariantData().find((variant) => {
//         return !variant.options
//           .map((option, index) => {
//             return this.options[index] === option;
//           })
//           .includes(false);
//       });
//     }
//   }

//   updateMedia() {
//     if (!this.currentVariant || !this.currentVariant.featured_media) return;
//     const newMedia = document.querySelectorAll(
//       `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
//     );

//     if (!newMedia) return;
//     const modalContent = document.querySelector(
//       `#ProductModal-${this.dataset.section} .product-media-modal__content`
//     );
//     const newMediaModal = modalContent
//       ? modalContent.querySelector(
//           `[data-media-id="${this.currentVariant.featured_media.id}"]`
//         )
//       : null;

//     let parent;
//     for (const media of newMedia) {
//       // there might be multiple of the same media element, some not visible on certain screen-sizes
//       parent = media.parentElement;
//       if (parent.firstChild == newMedia || !parent) return;
//       parent.prepend(media);
//     }
//     if (modalContent) {
//       modalContent.prepend(newMediaModal);
//     }
//     this.stickyHeader =
//       this.stickyHeader || document.querySelector("sticky-header") || null;
//     if (this.stickyHeader) {
//       this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
//     }
//     window.setTimeout(() => {
//       if (!parent) return;
//       const item = parent.querySelector("li.product__media-item");
//       if (item) {
//         item.scrollIntoView({ behavior: "smooth" });
//       }
//     });
//   }

//   updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === "false") return;
//     window.history.replaceState(
//       {},
//       "",
//       `${this.dataset.url}?variant=${this.currentVariant.id}`
//     );
//   }

//   /**
//    * param {Variant | null} variant
//    */
//   updateVariantInput(variant = null) {
//     const productForms = document.querySelectorAll(
//       `#product-form-${this.dataset.section}, #product-form-installment`
//     );
//     // console.log("product forms: ", productForms);

//     productForms.forEach((productForm) => {
//       // console.log("product form:", productForm);
//       /**
//        * @type {HTMLInputElement | null}
//        * */
//       const input = productForm.querySelector('input[name="id"]');
//       /**
//        * @type {HTMLInputElement | null}
//        * */
//       const skuElement = productForm.querySelector('input[name="sku"]');
//         console.log(
//         );
//         return;
//       }

//       if (!skuElement) {
//         console.log(
//           "Could not find sku element, might not be rendered yet...?"
//         );
//       }

//       if (variant) {
//         input.value = variant.id;
//         if (skuElement) {
//           skuElement.value = variant.sku;
//         }
//       } else {
//         input.value = this.currentVariant.id;
//         if (skuElement) {
//           skuElement.value = this.currentVariant.sku;
//         }
//       }
//       input.dispatchEvent(new Event("change", { bubbles: true }));
//     });
//   }

//   updatePickupAvailability() {
//     const pickUpAvailability = document.querySelector("pickup-availability");
//     if (!pickUpAvailability) return;

//     if (this.currentVariant && this.currentVariant.available) {
//       pickUpAvailability.fetchAvailability(this.currentVariant.id);
//     } else {
//       pickUpAvailability.removeAttribute("available");
//       pickUpAvailability.innerHTML = "";
//     }
//   }

//   // set

//   setUnavailable() {
//     const productForm = document.getElementById(
//       `product-form-${this.dataset.section}`
//     );

//     let addButton = null;
//     if (productForm) {
//       addButton = productForm.querySelector('[name="add"]');
//     }
//     if (!addButton) return;
//     addButton.textContent = window.variantStrings.unavailable;
//     this.hideFeatureUiElements(true);
//   }

//   setVariantUi(stateUi) {
//     // console.log(
//     //   "setting state UI: ",
//     //   stateUi,
//     //   "for variant: ",
//     //   this.currentVariant
//     // );
//     switch (stateUi) {
//       case knocking.variantState.regular:
//         this.setRegularUi();
//         break;
//       default:
//         console.error("Could not set state UI");
//         break;
//     }
//   }

//   setRegularUi() {
//     this.shipsByBanner.show();
//     // this.setShippingDate(this.currentVariant.state.shippingDate);
//     this.hideFeatureUiElements();
//     this.cleanUpPropertyInputs();
//   }

//   // get

//   getVariantData() {
//     this.variantData =
//       this.variantData ||
//       JSON.parse(this.querySelector('[type="application/json"]').textContent);
//     return this.variantData;
//   }

//   getVariantInventory() {
//     this.variantInventory = this.querySelector(
//       "#variant-quantities"
//     ).textContent.split("/");
//     for (let i = 0; i < this.variantData.length; i++) {
//       const variant = this.variantData[i];
//       variant.inventoryQuantity = this.variantInventory[i];
//     }
//   }

//   /**
//    *
//    * @returns {string[]}
//    */
//   getProductTags() {
//     /**
//      * @type {HTMLScriptElement | null}
//      */
//     const tagelement = this.querySelector('[data-id^="product-data-tags"]');
//     if (!tagelement || !tagelement.textContent) {
//       return [];
//     }

//     const tags = JSON.parse(tagelement.textContent);

//     return tags;
//   }

//   getVariantContinueSellingPolicy() {
//     this.variantPolicies = this.querySelector("#variant-policies").textContent;

//     while (this.variantPolicies.includes('"')) {
//       this.variantPolicies = this.variantPolicies.replace('"', "");
//     }

//     this.variantPolicies = this.variantPolicies.split("/");

//     for (let i = 0; i < this.variantData.length; i++) {
//       const variant = this.variantData[i];
//       variant.inventoryPolicy = this.variantPolicies[i];
//     }
//   }

//   // add/append

//   addFeaturePropertiesToVariantData() {
//     for (let i = 0; i < this.variantData.length; i++) {
//       const variant = this.variantData[i];
//       variant.state = {
//         ui: knocking.variantState.regular,
//         shippingDate: knocking.getTagShippingDate(this.productTags),
//       };
//     }
//   }

//   appendProperty(name, value, visible = false) {
//     let productForm = document.querySelector(
//       'form[id^="product-form-template"]'
//     );
//     let propertyInput = document.createElement("input");
//     let nameProperty;
//     if (visible) {
//       nameProperty = `properties[${name}]`;
//     } else {
//       nameProperty = `properties[_${name}]`;
//     }
//     propertyInput.setAttribute("type", "hidden");
//     propertyInput.setAttribute("name", nameProperty);
//     propertyInput.setAttribute("value", value);
//     productForm.appendChild(propertyInput);
//   }

//   // feature methods

//   hideFeatureUiElements(hideShipsBy = false) {
//     if (hideShipsBy) this.shipsByBanner.hide();
//   }

//   checkShippingFeatures() {
//     // this.setUndefinedVariantStatesToRegular();
//   }

//   cleanUpPropertyInputs() {
//     const productForm = document.querySelector(
//       'form[id^="product-form-template"]'
//     );
//     const inputs = Array.from(productForm.querySelectorAll("input"));
//     const propertyInputs = inputs.filter((input) => {
//       const name = input.getAttribute("name");
//       if (name.includes("properties")) {
//         return input;
//       }
//     });
//   }
// }

// customElements.define("variant-selects", VariantSelects);

// class VariantRadios extends VariantSelects {
//   constructor() {
//     super();
//   }

//   updateOptions() {
//     const fieldsets = Array.from(this.querySelectorAll("fieldset"));
//     this.options = fieldsets.map((fieldset) => {
//       return Array.from(fieldset.querySelectorAll("input")).find(
//         (radio) => radio.checked
//       ).value;
//     });
//   }
// }

// customElements.define("variant-radios", VariantRadios);
